import React from 'react';
import { motion } from 'framer-motion';

const logos = [
  { name: 'Lieferando', color: '#FF8000' },
  { name: 'Wolt', color: '#00C2E8' },
  { name: 'Uber Eats', color: '#06C167' },
  { name: 'DATEV', color: '#00A3E0' },
  { name: 'SumUp', color: '#1A1F71' },
  { name: 'Nexi', color: '#003399' },
  { name: 'fiskaly TSE', color: '#00B67A' },
  { name: 'Google Pay', color: '#4285F4' },
  { name: 'Apple Pay', color: '#000000' }
];

export const InfiniteLogoScroll = ({ className = '', speed = 30 }) => {
  // Duplicate logos for seamless loop
  const allLogos = [...logos, ...logos, ...logos];

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Gradient Masks */}
      <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-[#0B1220] to-transparent z-10" />
      <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-[#0B1220] to-transparent z-10" />
      
      {/* Scrolling Container */}
      <motion.div
        className="flex items-center gap-12"
        animate={{
          x: [0, -100 * logos.length]
        }}
        transition={{
          x: {
            repeat: Infinity,
            repeatType: 'loop',
            duration: speed,
            ease: 'linear'
          }
        }}
      >
        {allLogos.map((logo, i) => (
          <div
            key={`${logo.name}-${i}`}
            className="flex-shrink-0 px-6 py-3 bg-white/5 rounded-lg border border-white/10 hover:bg-white/10 transition-colors"
          >
            <span 
              className="text-lg font-semibold whitespace-nowrap"
              style={{ color: logo.color }}
            >
              {logo.name}
            </span>
          </div>
        ))}
      </motion.div>
    </div>
  );
};

// Static logo grid for mobile/reduced motion
export const LogoGrid = ({ className = '' }) => {
  return (
    <div className={`grid grid-cols-3 md:grid-cols-5 gap-4 ${className}`}>
      {logos.slice(0, 5).map((logo) => (
        <div
          key={logo.name}
          className="flex items-center justify-center px-4 py-3 bg-white/5 rounded-lg border border-white/10"
        >
          <span 
            className="text-sm font-medium"
            style={{ color: logo.color }}
          >
            {logo.name}
          </span>
        </div>
      ))}
    </div>
  );
};

export default InfiniteLogoScroll;
